module.exports = __webpack_public_path__ + "static/media/avi.cafab79c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/avi.svg
// module id = 1678
// module chunks = 17